/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Entity } from '../model/entity/entity';

export class MockEntity extends Entity {
  public id: string;
  public label: string;
  public displayId: boolean;
  public icon: string;

  constructor(
    id: string,
    label: string,
    displayId = false,
    displayLabel = true,
  ) {
    super();
    this.id = id;
    this.label = label;
    this.displayId = displayId;
    void displayLabel;
  }

  public override convert(item): Entity {
    return new MockEntity(item.id, item.label);
  }

  getApi(): string {
    return '';
  }

  getId(): string {
    return this.id;
  }
  getLabel(): string {
    return this.label;
  }

  public override toString(): string {
    if (this.id && this.displayId) {
      return `(${this.id}) ${this.label}`;
    }
    return this.label;
  }

  serialize() {
    return;
  }
}
